// React
import { FunctionComponent } from "react";

// Styles
import "./VehicleIncidentsActionOption.css";

// Props interface
interface Props {
    callback: VoidFunction; // Called when option is clicked
    checked: boolean;       // Controls visual selection state
    title: string;          // Displayed label
    icon: string;           // Material icon name
}

// Functional component for rendering a single selectable action option
const VehicleIncidentsActionOption: FunctionComponent<Props> = (props) => {
    const { callback, checked, title, icon } = props;

    return (
        <div
            // Toggle class based on "checked" state
            className={`VehicleIncidentsActionOption ${checked
                    ? "VehicleIncidentsActionOptionChecked"
                    : "VehicleIncidentsActionOptionNotChecked"
                }`}
            onClick={callback}
        >
            {/* Label and icon layout */}
            <div className="VehicleIncidentsActionOptionTitle">
                <p>{title}</p>
                <span className="material-icons-outlined">{icon}</span>
            </div>
        </div>
    );
};

export default VehicleIncidentsActionOption;
